import styled from 'styled-components';

export const Link = styled.a`
  ${(props) => {
    let textColor = props.theme.palette.white;
    let backgroundColor = props.color
      ? props.color
      : props.theme.palette.primary.main;
    let borderColor = 'transparent';
    if (props.variant && props.variant === 'outlined') {
      backgroundColor = props.theme.palette.white;
      borderColor = props.color
        ? props.color
        : props.theme.palette.primary.main;
      textColor = props.color ? props.color : props.theme.palette.primary.main;
    }
    return {
      'background-color': backgroundColor,
      'border-color': borderColor,
      color: textColor,
    };
  }};
  border-width: 1px;
  border-style: solid;
  min-height: 50px;
  border-radius: 8px;
  font-weight: 500;
  margin: ${({ margin }) => margin};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ fontSize }) => fontSize || '16px'};
  text-decoration: none;
`;
